export const NONE = 'none';
export const THIRD_PARTY = '3rd party';
export const RETAILERS = 'retailers';
